import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { css } from 'styled-components'

type ArrowIconProps = {
  className?: string
  direction?: 'up' | 'down' | 'left' | 'right' | 'up-right'
} & ComponentProps<'svg'>

const style = css`
  &.ArrowIcon {
    &.up {
      transform: rotate(270deg);
    }
    &.down {
      transform: rotate(90deg);
    }
    &.left {
      transform: rotate(180deg);
    }
    &.right {
      transform: rotate(0deg);
    }
    &.up-right {
      transform: rotate(315deg);
    }
  }
`

export default function ArrowIcon(props: ArrowIconProps) {
  const { className = '', direction = 'right', ...rest } = props
  return (
    <svg
      css={style}
      className={cn('ArrowIcon', className, direction)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fill="currentColor"
        d="m16.69 13.25-4.72 4.72a.75.75 0 0 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06l-6-6a.75.75 0 0 0-1.06 1.06l4.72 4.72H5.5a.75.75 0 0 0 0 1.5h11.19Z"
      />
    </svg>
  )
}
